import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const FormSuccess = () => {
  const enrollmentId = localStorage.getItem('enrollmentId');

  useEffect(() => {
    // Clear enrollmentId after the component has rendered
    localStorage.removeItem('enrollmentId');
  }, []);
  
  return (
    <div className="success-container">
      <div className="success-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
      </div>
      <h2>Registration Successful!</h2>
      <p>Your registration has been completed successfully. We have sent a confirmation email with all the details to your registered email address.</p>
      <p>Your registration ID: <strong>{enrollmentId || "Not available. Please contact support."}</strong></p>
      
      <div className="email-note">
        <div className="note-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4"></path>
            <path d="M12 8h.01"></path>
          </svg>
        </div>
        <p><strong>Note:</strong> If you don't see the confirmation email in your inbox within the next few minutes, please check your spam/junk folder. Sometimes automated emails can end up there.</p>
      </div>
      
      <div className="next-steps">
        <h3>Next Steps</h3>
        <ol>
          <li>Check your email for confirmation (including spam folder)</li>
          <li>Save your registration ID for future reference</li>
          <li>Prepare for your first class</li>
        </ol>
      </div>
      <div className="form-actions">
        <Link to="https://educatory.ac" className="btn btn-primary">Back to Website</Link>
      </div>
    </div>
  );
};

export default FormSuccess;